'use strict';

import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames/bind';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { appSelectors, appOperations } from '@/state/domains/app';
import { usersOperations, usersSelectors } from '@/state/domains/users';

import Back from '../components/Back';
import BtnImp from '../components/BtnImp';
import GoDate from '../components/GoDate';
import GoHome from '../components/GoHome';
import GoList from '../components/GoList';
import GoLocation from '../components/GoLocation';
import GoMap from '../components/GoMap';
import GoNext from '../components/GoNext';
import GoPrev from '../components/GoPrev';
import GoRoute from '../components/GoRoute';

import s from './styles.scss';

const sx = cn.bind(s);

const buttonsMap = {
	settings: [
		GoHome,
	],
	'daily-route': [
		Back,
		GoHome,
		GoList,
		GoMap,
		GoDate,
	],
	'daily-location': [
		Back,
		GoHome,
		GoList,
		GoMap,
		GoLocation,
	],
};

export default connect(
	(state, props) => ({
		isMenuOpen: appSelectors.isRouterInProgress(state, props),
		location: appSelectors.getLocation(state, props),
		pageId: appSelectors.getPageId(state, props),
		urlParams: appSelectors.getUrlParams(state, props),
		user: usersSelectors.getPageUser(state, props),
		actionMode: appSelectors.getActionMode(state, props),
	}),
	{
		updateClientWidth: appOperations.updateClientWidth,
		setMenuOpen: appOperations.setMenuOpen,
		setMenuClose: appOperations.setMenuClose,
	}
)(
	({
		isMenuOpen,
		location,
		page,
		pageId,
		actionMode,
		toggleImport,
		urlParams,
		updateClientWidth,
		setMenuOpen,
		setMenuClose,
	}) => {

		const ref = useRef(null);

		useEffect(() => {

			let timeoutId = null;

			const resizeListener = () => {
				clearTimeout(timeoutId);
				timeoutId = setTimeout(() => {
					updateClientWidth(ref.current.clientWidth);
				}, 150);
			};

			window.addEventListener('resize', resizeListener);

			resizeListener();

			return () => {
				window.removeEventListener('resize', resizeListener);
			};
		}, []);

		let buttons = buttonsMap[ pageId ] || [ Back, BtnImp, GoDate ];

		if (
			[ 'user-weekly', 'daily-route' ].includes(pageId) &&
			location.state &&
			location.state.dateMode
		) {
			buttons = [
				GoPrev,
				GoDate,
				GoNext,
			];
		}

		return (
			<>
				<div
					onClick={ () => isMenuOpen ? setMenuClose() : setMenuOpen() }
					className={ sx('menuBtn') }
				>
					<FontAwesomeIcon icon='bars' color='#444'/>
				</div>
				<div className={ s.headerBtns }>
					{
						buttons.map((Comp, key) => (
							<div className={ s.headerBtn } key={ key } >
								<Comp { ...urlParams } />
							</div>
						))
					}
				</div>
				<div className={ s.headerBtn } style={{ width: '50px' }}></div>
			</>
		);
	}
);
